import  imagemEstadoBom  from '@/assets/estadoPneus/bom.png'
import  imagemEstadoRegular  from '@/assets/estadoPneus/regular.png'
import  imagemEstadoRuim  from '@/assets/estadoPneus/ruim.png'
import FuncoesHelper from '@/helpers/FuncoesHelper'

export default class EstadoPneusConstant {
    static ESTADOS = [
        { 
            estado: 'Ruim',
            imagem: imagemEstadoRuim
        },
    
        { 
            estado: 'Regular',
            imagem: imagemEstadoRegular
        },
        { 
            estado: 'Bom',
            imagem: imagemEstadoBom
        },
    ]
    
    static TIPOS = [
        {
            descricao: 'Dianteiro',
            id: FuncoesHelper.gerarUuid(),
            estadoSelecionado: 'Regular'
        },
        {
            descricao: 'Traseiro',
            id: FuncoesHelper.gerarUuid(),
            estadoSelecionado: 'Regular'
        },
        {
            descricao: 'Estepe',
            id: FuncoesHelper.gerarUuid(),
            estadoSelecionado: 'Regular'
        }
    ]
}